import { Http } from '@/lib/http';

export class WorkflowStagesService extends Http {
  constructor() {
    super();
    this.endpoint = 'onboarder/settings/workflow-stages/';
  }

  getWorkflowStages() {
    return this.httpClient().get(`${this.endpoint}`);
  }

  updateWorkflowStage(workflow) {
    return this.httpClient().patch(`${this.endpoint}${workflow.id}`, workflow);
  }
}
